import { ExternalArticle } from '@/common/api/params/externalArticle'
import { dateTimeStr } from '@/common/form/date'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import TextButton from '@/components/view/atoms/button/TextButton'
import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import ClickableTableRow from '@/components/view/atoms/table/ClickableTableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'
import ExternalLink from '@/components/view/utils/link/ExternalLink'

import ExternalArticleStatusBadge from '@/components/container/page/site/externalArticle/ExternalArticleStatusBadge'

interface Props {
  article: ExternalArticle
  refetching: boolean
  onClick(): void
  onRefetch(): void
  onDelete(): void
}

const ExternalArticleListRow = ({ article, refetching, onClick, onRefetch, onDelete }: Props) => {
  return (
    <ClickableTableRow onClick={onClick}>
      <TableRowItem width={320}>
        <ItemAlign gapY={2}>
          <Text size={13} color={TextColor.TERTIARY}>
            {article.article_id}
          </Text>
          <Text size={13} weight='bold'>
            {article.title || '（未取得）'}
          </Text>
          {article.fail_reason && (
            <Text size={10} color={TextColor.CRITICAL}>
              {article.fail_reason}
            </Text>
          )}
        </ItemAlign>
      </TableRowItem>
      <TableRowItem width={188}>
        <TextButton size={12} color={TextColor.LINK} link={article.url} newTab>
          {article.source_host || '—'}
        </TextButton>
      </TableRowItem>
      <TableRowItem width={128}>
        <ExternalArticleStatusBadge status={article.status} label={article.status_label} />
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={12}>{article.view_count.toLocaleString()}</Text>
      </TableRowItem>
      <TableRowItem width={160}>
        <Text size={12} color={TextColor.SECONDARY} nowrap>
          {article.published_at ? dateTimeStr(article.published_at, { omitSecond: true }) : '—'}
        </Text>
      </TableRowItem>
      <TableRowItem width={160}>
        <Text size={12} color={TextColor.SECONDARY} nowrap>
          {article.last_fetched_at
            ? dateTimeStr(article.last_fetched_at, { omitSecond: true })
            : '—'}
        </Text>
      </TableRowItem>
      <TableRowItem width={188}>
        <ItemAlign gapX={8} align='center' nowrap>
          <Button
            color={ButtonColor.SECONDARY}
            loading={refetching}
            disabled={refetching}
            onClick={onRefetch}
          >
            再取込
          </Button>
          <Button color={ButtonColor.SECONDARY} square onClick={onDelete}>
            <Icon type={IconType.DELETE} color={IconColor.CRITICAL} line />
          </Button>
        </ItemAlign>
      </TableRowItem>
    </ClickableTableRow>
  )
}

export default ExternalArticleListRow
